import React, { useState } from 'react';

const AllNFTsFilter = ({ activeTab, setActiveTab }) => {
  return (
    <div className="menu_categories bg_white w-100 d-flex">
      <button
        className={`btn btn-white btn-sm m-3 ${activeTab === "all" ? "btn-dark text-white" : ""}`}
        onClick={() => setActiveTab("all")}
      >
        All
      </button>
      <button
        className={`btn btn-white btn-sm m-3 ${activeTab === "games" ? "btn-dark text-white" : ""}`}
        onClick={() => setActiveTab("games")}
      >
        <i className="ri-gamepad-line" /> Games
      </button>
      <button
        className={`btn btn-white btn-sm m-3 ${activeTab === "art" ? "btn-dark text-white" : ""}`}
        onClick={() => setActiveTab("Art")}
      >
        <i className="ri-brush-line" /> Art
      </button>
      <button
        className={`btn btn-white btn-sm m-3 ${activeTab === "tradingCards" ? "btn-dark text-white" : ""}`}
        onClick={() => setActiveTab("tradingCards")}
      >
        <i className="ri-stock-line" /> Trading Cards
      </button>
      <button
        className={`btn btn-white btn-sm m-3 ${activeTab === "music" ? "btn-dark text-white" : ""}`}
        onClick={() => setActiveTab("music")}
      >
        <i className="ri-music-line" /> Music
      </button>
      <button
        className={`btn btn-white btn-sm m-3 ${activeTab === "domainNames" ? "btn-dark text-white" : ""}`}
        onClick={() => setActiveTab("domainNames")}
      >
        <i className="ri-global-line" /> Domain Names
      </button>
      <button
        className={`btn btn-white btn-sm m-3 ${activeTab === "memes" ? "btn-dark text-white" : ""}`}
        onClick={() => setActiveTab("memes")}
      >
        <i className="ri-emotion-laugh-line" /> Memes
      </button>
      <button
        className={`btn btn-white btn-sm m-3 ${activeTab === "collectibles" ? "btn-dark text-white" : ""}`}
        onClick={() => setActiveTab("collectibles")}
      >
        <i className="ri-layout-4-line" /> Collectibles
      </button>
    </div>
  );
};

export default AllNFTsFilter;
